var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedInSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0077B5",
  d: "M22.223 0C23.2 0 24 .776 24 1.73v20.54c0 .957-.8 1.73-1.777 1.73H1.769C.793 24 0 23.227 0 22.27V1.73C0 .775.793 0 1.77 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M5.339 3.305a2.062 2.062 0 1 0 0 4.127 2.066 2.066 0 0 0 2.064-2.064 2.065 2.065 0 0 0-2.064-2.063M3.556 20.452H7.12V8.999H3.556zM9.352 8.999v11.453h3.556v-5.667c0-1.493.283-2.94 2.135-2.94 1.824 0 1.85 1.708 1.85 3.038v5.569h3.556v-6.281c0-3.086-.665-5.458-4.268-5.458-1.732 0-2.893.95-3.369 1.85h-.048V8.999z"
})));
export { SvgLinkedInSmall as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedInSmall.3339edf6.svg";